// 使用更安全的方式获取环境变量
const REACT_ENV = window.REACT_APP_ENV || 'production';

const baseUrlMaps = {
  // 本地
  'development': {
    dubboCrmBaseURL: 'https://tapi.apbenben.com/benben-dubbo-crm',
    bbMngBaseURL: '/mngPath',
    bbMngPath: 'https://sit.apbenben.com/league-mng',
    benbenPath: 'https://web-sit.apbenben.com',
    erpPath: 'https://test.erp.apware.cn',
    dubboErpDockingBaseURL: 'http://localhost:8080/dubbo-erp-docking-web',
    statsBaseURL: 'https://tapi.apbenben.com/stats'
  },
  // 测试
  'testing': {
    dubboCrmBaseURL: 'https://tapi.apbenben.com/benben-dubbo-crm',
    bbMngBaseURL: 'https://sit.apbenben.com/league-mng',
    bbMngPath: 'https://sit.apbenben.com/league-mng',
    benbenPath: 'https://web-sit.apbenben.com',
    erpPath: 'https://test.erp.apware.cn',
    dubboErpDockingBaseURL: 'https://sit.apbenben.com/dubbo-erp-docking-web',
    statsBaseURL: 'https://tapi.apbenben.com/stats'
  },
  // 预发布
  'pre': {
    dubboCrmBaseURL: 'https://papi.apbenben.com/benben-dubbo-crm',
    bbMngBaseURL: 'https://pre.apbenben.com/league-mng',
    bbMngPath: 'https://pre.apbenben.com/league-mng',
    benbenPath: 'https://pre.apbenben.com',
    erpPath: 'https://benben.erp.apware.cn',
    dubboErpDockingBaseURL: 'https://pre.apbenben.com/dubbo-erp-docking-web',
    statsBaseURL: 'https://api.apbenben.com/stats'
  },
  // 正式
  'production': {
    dubboCrmBaseURL: 'https://api.apbenben.com/benben-dubbo-crm',
    bbMngBaseURL: 'https://www.apbenben.com/league-mng',
    bbMngPath: 'https://www.apbenben.com/league-mng',
    benbenPath: 'https://web.apbenben.com',
    erpPath: 'https://benben.erp.apware.cn',
    dubboErpDockingBaseURL: 'https://www.apbenben.com/dubbo-erp-docking-web',
    statsBaseURL: 'https://api.apbenben.com/stats'
  }
};

// 检查 baseUrlMaps[REACT_ENV] 是否存在，如果不存在则使用 development 环境的配置
const config = baseUrlMaps[REACT_ENV] || baseUrlMaps['production'];
console.log('CommonURL配置:', config);
console.log('CommonURL配置env:', REACT_ENV);
export default config